import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-newpassword',
    templateUrl: './newpassword.component.html',
    styleUrls: ['./newpassword.component.scss'],
    standalone: false
})
export class NewpasswordComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
